/* unplugin-vue-components disabled */import script from "./footer.vue?vue&type=script&lang=jsx"
export * from "./footer.vue?vue&type=script&lang=jsx"

import "./footer.vue?vue&type=style&index=0&id=689073be&lang=css&scoped=true"
import "./footer.vue?vue&type=style&index=1&id=689073be&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-689073be"]])

export default __exports__